import yan2, { yan, B } from './test.js';

console.log(yan);
console.log(yan2, B);
console.log([].includes('yeah!'));
var a = 1 + 1;
var b = a;
console.log(a);
console.log(b);

export const name = 'base';
